import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllBatches, getBatchById, deleteBatch } from "../../../api/BatchApi";
import ProductBatchForm from "./ProductBatchForm";

export default function ProductBatchPage() {
  const [batches, setBatches] = useState([]);
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);

    const userRole = localStorage.getItem("role");
const navigate = useNavigate();


  const loadBatches = async () => {
    try {
      setLoading(true);
      const res = await getAllBatches();
      setBatches(res.data);
    } catch (err) {
      console.error("Data fetch error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadBatches(); }, []);

  const filteredBatches = batches.filter(b =>
    Object.values(b).some(val => String(val).toLowerCase().includes(search.toLowerCase()))
  );

  const handleDelete = async (id) => {

  try {

    const confirm = window.confirm("Are you sure you want to delete?");
    if (!confirm) return;

    await deleteBatch(id);

    alert("Deleted successfully");
    loadBatches();

  } catch (err) {

    // Prevent React crash
    console.error("Handled delete error:", err);

    // Show backend message
    const backendMessage =
      err.response?.data?.message ||
      err.response?.data?.error ||
      "You are not authorized to perform this action";

    alert(backendMessage);
  }
};

const handleEdit = async (id) => {
  try {
    const res = await getBatchById(id);
    setEditData(res.data);   // full batch with reportsJson
    setShowForm(true);
  } catch (err) {
    console.error("Failed to load batch", err);
    alert("Failed to load batch details");
  }
};


  return (
    <div className="container-fluid py-3 px-2 px-md-4 min-vh-100 bg-white">
      {/* COMPACT HEADER */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
        <div>
          <h5 className="fw-bold mb-0">Batch Records</h5>
        </div>
        <div className="d-flex gap-2">
          <div className="input-group input-group-sm border rounded shadow-sm">
            <span className="input-group-text bg-white border-0"><i className="bi bi-search"></i></span>
            <input
              type="text"
              className="form-control border-0 shadow-none"
              placeholder="Search..."
              style={{ width: '150px' }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button
            className="btn btn-sm btn-primary fw-bold px-3 shadow-sm rounded"
            onClick={() => { setEditData(null); setShowForm(true); }}
          >
            + Add Batch
          </button>
        </div>
      </div>

      {/* ENTERPRISE TABLE */}
      <div className="card border shadow-sm rounded-3">
        <div className="table-responsive">
          <table className="table table-sm table-hover align-middle mb-0" style={{ fontSize: '0.82rem' }}>
           <thead className="bg-light">
            <tr className="text-muted fw-bold">
              <th className="ps-3 py-2">PRODUCT CODE</th>
              <th className="py-2">PRODUCT NAME</th>
              <th className="py-2">BATCH NUMBER</th>
              <th className="py-2">MFG DATE</th>
              <th className="py-2">EXPIRY DATE</th>
              <th className="py-2">COUNTRY</th>
              <th className="py-2">REPORT STATUS</th>
              <th className="pe-3 py-2 text-end">ACTIONS</th>
            </tr>
          </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center py-5">
                    <div className="spinner-border spinner-border-sm text-primary me-2"></div>
                    Loading...
                  </td>
                </tr>
              ) : filteredBatches.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-5 text-muted">
                    No records found
                  </td>
                </tr>
              ) : (
                filteredBatches.map((batch) => (
                  <tr key={batch.id}>
                    
                    <td className="ps-3 py-2 fw-bold">
                      {batch.productCode}
                    </td>

                    <td className="py-2">
                      {batch.productName || "-"}
                    </td>

                   <td className="py-2">
                      <span
                        className="text-primary fw-semibold"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`/AdminDashboard/batch-view/${batch.id}`)}
                      >
                        {batch.batchName || batch.batchNumber}
                      </span>
                    </td>


                    <td className="py-2">
                      {batch.manufacturingDate || "-"}
                    </td>

                    <td className="py-2">
                      {batch.expiryDate || "-"}
                    </td>

                    <td className="py-2">
                      {batch.country || "-"}
                    </td>

                    <td className="py-2">
                      <div className="text-truncate" style={{ maxWidth: '160px' }}>
                        {batch.reportStatus || "Pending"}
                      </div>
                    </td>

                    <td className="pe-3 py-2 text-end">
                      <div className="dropdown">
                        <i
                          className="bi bi-three-dots-vertical cursor-pointer px-2 py-1 rounded hover-bg-light"
                          data-bs-toggle="dropdown"
                        ></i>

                        <ul className="dropdown-menu dropdown-menu-end shadow border-0 small">
                          <li>
                            <button
                              className="dropdown-item py-2"
                              onClick={() => handleEdit(batch.id)}
                            >
                              <i className="bi bi-pencil me-2"></i>Edit
                            </button>
                          </li>

                          <li><hr className="dropdown-divider" /></li>

                          <li>
                            <button
                              className="dropdown-item text-danger py-2"
                              onClick={() => handleDelete(batch.id)}
                            >
                              <i className="bi bi-trash me-2"></i>Delete
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>

                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>
      </div>

      {/* FORM MODAL */}
      {showForm && (
        <ProductBatchForm
          closeForm={() => setShowForm(false)}
          reloadData={loadBatches}
          editData={editData}
        />
      )}

      <style>{`
        .btn-xs { padding: 1px 5px; font-size: 0.7rem; line-height: 1.5; border-radius: 3px; }
        th { font-size: 0.7rem; letter-spacing: 0.5px; }
        .cursor-pointer { cursor: pointer; }
        .hover-bg-light:hover { background-color: #f8f9fa; }
      `}</style>
    </div>
  );
}